<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("resellers.tabs.groups") }}
      UiStackItem
        UiButton(
          @click="addCompanyGroup"
          icon="Plus"
        ) {{ $t("resellers.add_group") }}
  UiCardSection
    RestTable(
      namespace="reseller_company_groups"
      :headers="headers"
      ref="resellersCompanyGroupsTable"
      :fetch-handler="getData"
      embed
    )
      template(#cell:actions="{ item }")
        UiStack(spacing="xs")
          UiButton(
            size="sm"
            variant="smooth-primary"
            @click="editCompanyGroup(item)"
            icon="PencilCreate"
          ) {{ $t("actions.edit") }}
          UiButton(
            size="sm"
            variant="smooth-danger"
            @click="deleteCompanyGroup(item)"
            icon="Trash"
          ) {{ $t("actions.delete") }}
  EditCompanyGroupModal(
    ref="EditCompanyGroupModal"
    @done="reloadList"
  )
</template>

<script>
import router from "@/router";
import ApiResellers from "@/api/resellers.js";
import EditCompanyGroupModal from "@/modals/Resellers/editCompanyGroup.vue";

export default {
  components: {
    EditCompanyGroupModal,
  },

  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reloadList() {
      this.$refs.resellersCompanyGroupsTable.fetchData();
    },
    getData(params, config) {
      return ApiResellers.fetchResellerCompanyGroups(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.reseller_company_groups,
          meta: resp.data.meta,
        };
      });
    },

    editCompanyGroup(item) {
      this.$refs.EditCompanyGroupModal.open(this.$route.params.id, item);
    },

    deleteCompanyGroup(item) {
      ApiResellers.deleteResellerCompanyGroup(
        this.$route.params.id,
        item.id,
      ).then((resp) => {
        this.reloadList();
      });
    },

    addCompanyGroup() {
      this.$refs.EditCompanyGroupModal.open(this.$route.params.id, null);
    },

    goBack() {
      router.push("/resellers");
    },
  },
};
</script>
